import { useLocation, useNavigate } from "react-router-dom";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/atomic/SelectBox";
import { useWorkspaces } from "@/hooks/useWorkspaces";

const WorkspaceSwitch: React.FC = () => {
  const { workspaces, sessionCurrentWorkspaceId, setWorkspaceId } = useWorkspaces();
  const location = useLocation();
  const navigate = useNavigate();

  const options = workspaces?.map((workspace) => ({
    label: workspace.name,
    value: workspace.id,
  })) ?? [];

  const onValueChange = (value: string) => {
    if (location.pathname.includes(sessionCurrentWorkspaceId)) {
      // URLにworkspaceIdが含まれているページではURL変更 -> 遷移後にLayoutでsetWorkspaceIdが呼ばれる
      navigate(location.pathname.replace(sessionCurrentWorkspaceId, value));
    } else {
      // URLにworkspaceIdが含まれていないページでは直接setWorkspaceIdで書き換え
      setWorkspaceId(value);
    }
  };

  return (
    <Select value={sessionCurrentWorkspaceId} onValueChange={onValueChange}>
      <SelectTrigger
        className="h-[42px] border-0 cursor-pointer w-auto gap-1"
        data-testid="workspace-switch-trigger"
      >
        <SelectValue />
      </SelectTrigger>
      <SelectContent position="popper" align="end" className="z-100">
        {options.map((opt) => (
          <SelectItem key={opt.value} value={opt.value}>
            {opt.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default WorkspaceSwitch;
